import { render, staticRenderFns } from "./SingleImage3.vue?vue&type=template&id=4b33627e&scoped=true"
import script from "./SingleImage3.vue?vue&type=script&lang=js"
export * from "./SingleImage3.vue?vue&type=script&lang=js"
import style0 from "./SingleImage3.vue?vue&type=style&index=0&id=4b33627e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33627e",
  null
  
)

export default component.exports